<template>
  <div class="pa-5">
    <v-row style="margin-top: 10px">
      <v-col>
        <v-card height="400px">
          <v-sheet elevation="0" width="200px" height="125px" color="green" dark style="position: relative; top: -20px; left: 20px; padding: 5px;">
            <div><b>Staged Updates</b></div>
            <div style="width:100%; text-align: center; font-size: 40px; margin-top: 20px">{{stagedUpdateCount}}</div>
            <div style="width:100%; text-align: center; font-size: 10px"><i>ready to download</i></div>
          </v-sheet>
          <div style="width: 100%; text-align: center;">
            <column-chart :data="stagedUpdateData" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-card height="400px">
          <v-sheet elevation="0" width="250px" height="125px" color="cyan" dark style="position: relative; top: -20px; left: 20px; padding: 5px;">
            <div><b>Installed Versions</b></div>
            <div style="width:100%; text-align: center; font-size: 40px; margin-top: 20px">{{alignersAtLatestSoftwareVersion}}</div>
            <div style="width:100%; text-align: center; font-size: 10px;"><i>latest/total</i></div>
          </v-sheet>
          <div style="width: 100%; text-align: center;">
            <column-chart :library="chartOptions" :data="installedVersionsData" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {
  },

  computed: {
    chartOptions() {
      return {
        vAxis: {
          scaleType: 'log',
        },
      };
    },

    stagedUpdateCount() {
      return this.$store.state.stagedUpdateTotals.total;
    },

    stagedUpdateData() {
      const result = [];

      if (this.$store.state.stagedUpdateTotals) {
        Object.keys(this.$store.state.stagedUpdateTotals.versions).forEach((version) => {
          result.push([version, this.$store.state.stagedUpdateTotals.versions[version]]);
        });
      }

      return result;
    },

    alignersAtLatestSoftwareVersion() {
      const { latestSoftwareVersion } = this.$store.state;
      let totalAligners = 0;
      let alignersAtLatest = 0;

      this.$store.state.alignerSoftwareVersions.forEach((cur) => {
        if (cur.version === latestSoftwareVersion.semantic) {
          alignersAtLatest = cur.total;
        }

        totalAligners += cur.total;
      });

      return `${alignersAtLatest}/${totalAligners}`;
    },

    installedVersionsData() {
      const result = [];

      this.$store.state.alignerSoftwareVersions.forEach((cur) => {
        if (cur.total > 1) {
          result.push([cur.version, cur.total]);
        }
      });

      return result;
    },
  },
};
</script>
